module.exports = __webpack_public_path__ + "static/media/NotasFiscais4.735e1f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais4.png
// module id = 2134
// module chunks = 0